import { styled } from 'styled-components'
import {
  Block,
  Expander,
  Heading as SuomifiHeading,
} from 'suomifi-ui-components'
import { responsiveMaxWidth } from 'common-ui-components/src/vtj/theme/helpers'
import media from 'common-ui-components/src/vtj/theme/media'

export const Main = styled.main`
  flex-grow: 1;
  align-self: center;
  width: 100%;
  ${responsiveMaxWidth()}

  /* This is the same underline behavior as with suomifi Link underline='initial',
     which we should be using in most cases (OIVA-2320). This definition is needed
     for links that come from inside translated content. */
  a {
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
`
export const Heading = styled(SuomifiHeading)``
export const ContentSection = styled(Block).attrs({ variant: 'section' })`
  & > ${Heading} {
    margin-bottom: ${({ theme }) => theme.spacing.m};
  }
  & > p {
    margin-bottom: ${({ theme }) => theme.spacing.m};
  }
  & > .fi-link-list {
    margin: ${({ theme }) => theme.spacing.l} 0;
    li + li {
      margin-top: ${({ theme }) => theme.spacing.s};
    }
  }
`
export const ContentBlock = styled(Block)`
  margin-bottom: ${(props) => props.theme.spacing.xxxl} !important;
  box-sizing: border-box;

  /* Auto layout */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${(props) => props.theme.spacing.m};

  background: #ffffff;
  border: ${(props) => `1px solid ${props.theme.colors.depthLight1}`};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25);

  ${media.mobileContent} {
    padding-left: ${(props) => props.theme.spacing.s};
    padding-right: ${(props) => props.theme.spacing.s};
  }

  & > ${ContentSection} {
    margin-top: 0;
    margin-bottom: ${({ theme }) => theme.spacing.m};
    margin-left: ${({ theme }) => theme.spacing.m};
    margin-right: ${({ theme }) => theme.spacing.m};
    border-bottom: 1px solid ${({ theme }) => theme.colors.depthLight1};
    width: calc(100% - 2 * ${({ theme }) => theme.spacing.m});

    ${media.mobileAndTablet} {
      margin-left: 0;
      margin-right: 0;
      width: 100%;
    }

    & > *:last-child {
      margin-bottom: ${({ theme }) => theme.spacing.m};
    }

    & > .fi-expander-group:last-child {
      margin-bottom: ${({ theme }) => theme.spacing.xxl};
    }
  }

  & > ${ContentSection}:first-child {
    margin-bottom: 0;
  }

  & > ${ContentSection}:last-child {
    margin-bottom: 0;
    border: 0;
  }
`
export const StyledExpander = styled(Expander)`
  ul {
    padding-left: ${(props) => props.theme.spacing.m};
    list-style-type: disc;
  }
  .fi-link-list {
    margin: ${({ theme }) => theme.spacing.l} 0;
  }
`
export const TextBlockWithRows = styled(Block)<{ gap?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.gap ? `${props.gap}` : `${props.theme.spacing.m}`)};
  & > p {
    margin: 0;
    padding: 0;
  }
`
